export const JOIN_REQUEST_REJECTED_MESSAGE = 'Join request was rejected';

export class JoinRequestRejectedException extends Error {
  constructor() {
    super(JOIN_REQUEST_REJECTED_MESSAGE);
  }
}
